var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-option',{attrs:{"predefined":_vm.onMatchOption(_vm.item),"options":_vm.options},on:{"value":_vm.onValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }